import { Box, Button, Container, Typography } from "@mui/material";

import { useDarkThemeCheck } from "../../../Components/hooks/useDarkThemeCheck";
import BorderedBox from "../BorderedBox";
import SageMakerIcon from "../SavingsByService/assets/sagemaker.svg";
import { useEnableFlexsaveSageMaker } from "./hooks";

export default function EnableFlexsaveSageMaker() {
  const darkMode = useDarkThemeCheck();
  const color = darkMode ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.7)";
  const enable = useEnableFlexsaveSageMaker();

  return (
    <Container>
      <Box
        sx={{
          mt: 4,
          mb: 1,
        }}
      >
        <BorderedBox>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: 4,
              paddingRight: 4,
              paddingTop: 3,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="h2">Flexsave now supports SageMaker</Typography>

              <Typography
                sx={{
                  mt: 2,
                  color,
                }}
              >
                Now you can save even more with Flexsave for SageMaker. Enable by clicking the button below.{" "}
              </Typography>
            </Box>

            <img src={SageMakerIcon} alt="SageMaker con symbol" width={82} height={82} />
          </Box>

          <Box sx={{ paddingLeft: 4, paddingRight: 4, marginBottom: 3, marginTop: 1 }}>
            <Button variant="contained" color="primary" onClick={enable} data-cy="enable-flexsave-sagemaker">
              Enable for SageMaker
            </Button>
          </Box>
        </BorderedBox>
      </Box>
    </Container>
  );
}
